import { useState, useEffect } from "react";

export default function EventCountdown() {
  // Data dell'Evento: 7 Novembre 2026 alle 10:00
  const eventDate = new Date("2026-11-07T10:00:00").getTime();

  const [timeLeft, setTimeLeft] = useState({
    days: 0, hours: 0, minutes: 0, seconds: 0, isEventStarted: false
  });

  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = eventDate - now;

      if (distance < 0) {
        clearInterval(timer);
        setTimeLeft(prev => ({ ...prev, isEventStarted: true }));
      } else {
        setTimeLeft({
          days: Math.floor(distance / (1000 * 60 * 60 * 24)),
          hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((distance % (1000 * 60)) / 1000),
          isEventStarted: false
        });
      }
    }, 1000);
    return () => clearInterval(timer);
  }, [eventDate]);

  const TimeUnit = ({ value, label }) => (
    <div className="flex flex-col items-center px-4 md:px-10">
      <span className="bb-display text-6xl md:text-8xl lg:text-9xl text-[#c49a45] leading-none">
        {value.toString().padStart(2, '0')}
      </span>
      <span className="text-[10px] md:text-xs uppercase tracking-[0.4em] text-zinc-500 font-black mt-4">
        {label}
      </span>
    </div>
  );

  return (
    <section className="bg-black py-20 border-b border-zinc-900">
      <div className="bb-container text-center">
        {!timeLeft.isEventStarted ? (
          <>
            <div className="mb-12">
              <span className="uppercase tracking-[0.5em] text-[11px] font-bold text-[#c49a45] block mb-2">
                Save the Date
              </span>
              <h2 className="bb-display text-4xl md:text-5xl text-white uppercase leading-tight">
                L'Arena apre il <span className="text-white">7 Novembre</span>
              </h2>
            </div>
            
            <div className="flex justify-center items-center">
              <TimeUnit value={timeLeft.days} label="Giorni" />
              <div className="h-20 w-px bg-zinc-800 hidden md:block" />
              <TimeUnit value={timeLeft.hours} label="Ore" />
              <div className="h-20 w-px bg-zinc-800 hidden md:block" />
              <TimeUnit value={timeLeft.minutes} label="Minuti" />
              <div className="h-20 w-px bg-zinc-800 hidden md:block" />
              <TimeUnit value={timeLeft.seconds} label="Secondi" />
            </div>
          </>
        ) : (
          <div className="py-10">
            <h2 className="bb-display text-5xl text-[#c49a45] uppercase animate-pulse">
              L'Arena è Aperta
            </h2>
          </div>
        )}
      </div>
    </section>
  );
}